import { type ConfigurationEncode, CryptoHelper } from "@ecommerce/shared-utils";

const toBase64Url = (b64: string) =>
    b64.replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/g, "");

const fromBase64Url = (b64url: string) => {
    let b64 = b64url.replace(/-/g, "+").replace(/_/g, "/");
    const pad = b64.length % 4;
    if (pad) b64 += "=".repeat(4 - pad);
    return b64;
};

export class OrderResumeToken {
    static encodeGuid(encoder: ConfigurationEncode, guid: string): string {
        const cipherB64 = CryptoHelper.encrypt(encoder, guid);
        return toBase64Url(cipherB64);
    }

    static decodeGuid(encoder: ConfigurationEncode, token: string): string {
        const cipherB64 = fromBase64Url(token);
        return CryptoHelper.decrypt(encoder, cipherB64);
    }

    static isGuid(value: string): boolean {
        return /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(value);
    }
}














